import React from 'react';
import PropTypes from 'prop-types';

import { EditOutlined, VisibilityOutlined } from '@mui/icons-material';

import ListingToolbar from '../../Common/components/Listing/ListingToolbar';
import StatusChips from '../../Common/components/Listing/StatusChips';
import CommonTable from '../../Common/components/Listing/CommonTable';

import { ptMessageColumns, statusItems } from '../PTMessageConfig';

import { ptMessageRows } from '../data';

const PTMessageTable = ({
  search,
  activeTab,
  page,
  rowsPerPage,
  rows,
  totalCount,
  loading,
  onSearchChange,
  onStatusChange,
  onCreate,
  onPageChange,
  onRowsPerPageChange,
  onActionClick
}) => {
  return (
    <>
      <ListingToolbar
        search={search}
        searchPlaceholder="Search by patient, message, or status..."
        createLabel="Create Message"
        onSearchChange={onSearchChange}
        onCreate={onCreate}
      />

      <StatusChips
        items={statusItems}
        rows={ptMessageRows}
        activeValue={activeTab}
        onChange={onStatusChange}
      />

      <CommonTable
        columns={ptMessageColumns}
        rows={rows}
        totalCount={totalCount}
        page={page}
        actionWrapper
        loading={loading}
        skeletonRows={10}
        rowsPerPage={rowsPerPage}
        emptyText="No PT messages found."
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        onActionClick={onActionClick}
        renderAction={row =>
          row.status === 'Awaiting Clinic' ? (
            <EditOutlined fontSize="small" />
          ) : (
            <VisibilityOutlined fontSize="small" />
          )
        }
      />
    </>
  );
};

PTMessageTable.propTypes = {
  search: PropTypes.string.isRequired,
  activeTab: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  rows: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  onActionClick: PropTypes.func.isRequired
};

export default PTMessageTable;
